/* eslint-disable */
import { FaqEntryStatisticDto, fixFaqEntryStatisticDtoFromJson, fixFaqEntryStatisticDtoToJson } from '../dto/faq-entry-statistic-dto';

export interface FaqEntryStatisticOverviewDto {
  statistics: FaqEntryStatisticDto[];
  helpfulCount: number;
  unhelpfulCount: number;
  totalViewCount: number;
}

export const fixFaqEntryStatisticOverviewDtoFromJson = (dto?: FaqEntryStatisticOverviewDto | null): void => {
  if (!dto) {
    return;
  }
  dto.statistics?.forEach((x, i, a) => fixFaqEntryStatisticDtoFromJson(a[i]));
};

export const fixFaqEntryStatisticOverviewDtoToJson = (dto?: FaqEntryStatisticOverviewDto | null): void => {
  if (!dto) {
    return;
  }
  dto.statistics?.forEach((x, i, a) => fixFaqEntryStatisticDtoToJson(a[i]));
};
